import { EMAIL_REGEX } from '../../../../../helpers/constants'

export const mapClientToUser = ({ id, apartment: unit, user, phone, creditCardId }) => ({
  value: id,
  userId: user.id,
  label: `${user.firstName} ${user.lastName}`,
  email: user.email,
  phone,
  unit,
  creditCardId,
})

export const setMinMaxValue = (e, min = 1, max = 10000) => {
  if (isNaN(Number(e.target.value))) e.target.value = ''
  if (e.target.value < min) e.target.value = min
  if (e.target.value > max) e.target.value = max
  e.target.value = parseInt(e.target.value)
  return e
}

export const validateEmail = (val) => {
  return val.length > 0 && EMAIL_REGEX.test(val)
}

const renderDiscountLabel = (value = 0, t) => (
  <div className="discount-label">
    <div>
      ${value}{' '}
      <span>
        {t('rewards-gift:servicesDenominations.discountOff', {
          value: Math.ceil(value - value * 0.1),
        })}
      </span>
    </div>
  </div>
)

export const getServicesAvailableDenominations = (t) =>
  [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000,
    3000, 4000, 5000,
  ].map((value) => ({ value, label: renderDiscountLabel(value, t) }))

export const rewardLinkCashValueCustom = 'customValue'

export const getRewardLinkCashValueOptions = (t) => [
  {
    value: rewardLinkCashValueCustom,
    label: t('rewards-gift:rewardLink.customAmount'),
  },
  {
    value: 10,
    label: '$10',
  },
  {
    value: 25,
    label: '$25',
  },
  {
    value: 50,
    label: '$50',
  },
  {
    value: 100,
    label: '$100',
  },
  {
    value: 200,
    label: '$200',
  },
  {
    value: 300,
    label: '$300',
  },
  {
    value: 400,
    label: '$400',
  },
  {
    value: 500,
    label: '$500',
  },
  {
    value: 600,
    label: '$600',
  },
  {
    value: 700,
    label: '$700',
  },
  {
    value: 800,
    label: '$800',
  },
  {
    value: 900,
    label: '$900',
  },
  {
    value: 1000,
    label: '$1000',
  },
  {
    value: 2000,
    label: '$2000',
  },
  {
    value: 3000,
    label: '$3000',
  },
  {
    value: 4000,
    label: '$4000',
  },
  {
    value: 5000,
    label: '$5000',
  },
]
